import React from 'react';
import logoRP from '../../../public/RP.png';
import logoFE from '../../../public/FE_WEDU.png';
import logoUE from '../../../public/UE_EFS2.png';
import logoWSB from '../../../public/WSB2.png';
import { Row, Col } from 'antd';

const logoHeaderStyle: React.CSSProperties = {
    backgroundColor: '#f4f7fc',
    padding: 'clamp(18px, 5vh, 50px) 24px clamp(12px, 4vh, 42px)',
};

const logoStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '300px' /* Adjust this to your preferred logo size */,
    maxHeight: 'clamp(54px, 12vh, 140px)',
    height: 'auto',
    objectFit: 'contain',
};

const Logos = () => {
    return (
        <Row
            align={'middle'}
            gutter={[24, 18]}
            justify={'center'}
            style={logoHeaderStyle}
        >
            <Col xs={12} md={6} style={{ textAlign: 'center' }}>
                <img src={logoFE} alt="logo" style={logoStyle} />
            </Col>
            <Col xs={12} md={6} style={{ textAlign: 'center' }}>
                <img src={logoRP} alt="logo" style={logoStyle} />
            </Col>
            <Col xs={12} md={6} style={{ textAlign: 'center' }}>
                <img src={logoWSB} alt="logo" style={logoStyle} />
            </Col>
            <Col xs={12} md={6} style={{ textAlign: 'center' }}>
                <img src={logoUE} alt="logo" style={logoStyle} />
            </Col>
        </Row>
    );
};

export default Logos;
